import { useQuery } from '@tanstack/react-query'

import { conRespaldo } from '@/lib/campo/loUltimoQueSeSupo'
import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'
import type { MiSolicitud } from '@/lib/supabase/tipos-bd'

/** Lo que el operario pidió y en qué va. Lo esperando, primero. */
export function useMisSolicitudes() {
  const consulta = useQuery({
    queryKey: ['mis-solicitudes'],
    staleTime: 30 * 1000,
    // Con respaldo: en la obra hace falta saber qué lleva encima.
    queryFn: () =>
      conRespaldo<MiSolicitud[]>('mis-solicitudes', async () => {
        const { data, error } = await supabase.rpc('fn_mis_solicitudes')

        if (error) throw new Error(mensajeDeError(error))

        return ((data ?? []) as unknown as MiSolicitud[]).map((fila) => ({
          ...fila,
          horas_pedidas: fila.horas_pedidas === null ? null : Number(fila.horas_pedidas),
        }))
      }),
  })

  return {
    solicitudes: consulta.data ?? [],
    cargando: consulta.isLoading,
    error: consulta.error?.message ?? null,
  }
}
